import React, { useEffect, useRef, useState } from "react";
import { Button, Container } from "reactstrap";
import { Link as ScrollLink } from 'react-scroll';
import { useNavigate } from "react-router-dom";

import { videoSrc } from 'components/BackgroundVideo/BackgroundVideo';
import './LandingPageHeader.css';

const LandingPageHeader = ({event}) => {
  const pageHeader = useRef();
  const [videoLoaded, setVideoLoaded] = useState(false);
  const navigate = useNavigate();
  const handleNavigation = () => {
    navigate('/hyperdrive');
  }

  useEffect(() => {
    const handleScroll = () => {
      const windowScrollTop = window.pageYOffset / 3;
      pageHeader.current.style.transform = `translate3d(0, ${windowScrollTop}px, 0)`;
    };

    if (window.innerWidth < 991) {
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  useEffect(() => {
    const video = pageHeader.current.querySelector("video");
  
    if (video && !videoLoaded) {
      video.load();
    }
  }, [videoLoaded]);

  return (
    <div className="page-header" data-parallax={true} ref={pageHeader}>
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          objectFit: "cover",
          width: "100%",
          height: "150%",
          position: "absolute",
          top: 0,
          left: 0,
          opacity: videoLoaded ? 1 : 0, // Set opacity based on videoLoaded state
          transition: "opacity 0.5s ease-in-out", // Add a smooth transition
        }}
        onLoadedData={() => setVideoLoaded(true)} // Update state when the video is loaded
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="filter" />

      <Container>
        <div className="motto text-center container">
          <h1><span>Zero Friction ∙ Infinite Possibilities</span></h1>
          <h2 style={{ fontSize: '200%' }}><span>Unlocking a clean and quiet solution for the Urban Air Mobility mass market</span></h2>
          <br/>
          <ScrollLink
            activeClass="active"
            to="Company"
            href="#"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
          >
            <Button className="btn-round mr-1" color="neutral" outline onClick={handleNavigation}>
              Learn More
            </Button>
          </ScrollLink>
        </div>

        <Event event={event}/>;

      </Container>
    </div>
  );
};

const Event = ({event}) => {
  if (event == "") {
    return null;
  } else {
    return (
      <div className="welcome-container">
        <h2 style={{ fontSize: '200%' }}> 
          <EventSwitch event={event}/>
        </h2>
      </div>
    );
  }
}

const EventSwitch = ({event}) => {
  switch(event) {
    case 'be2024':
      return <span className="welcome-text">Welcome Breakthrough Energy Summit 2024!</span>;
    case 'tide2024':
      return <span className="welcome-text">Welcome TIDE 2024!</span>;
    default:
      return null;
  }
};

export default LandingPageHeader;
